export const customerRoutes = {
  path: "/customer",
  component: () => import("@/layouts/Customer/CustomerLayout.vue"),
  children: [
    {
      path: "settings",
      name: "custSettings",
      component: () => import("@/modules/Settings/views/Customer"),
      redirect: {
        name: "customer-settings-administrators",
      },
      children: [
        {
          path: "administrators",
          name: "customer-settings-administrators",
          component: () =>
            import(
              "@/modules/Settings/views/Customer/Administrators/index.vue"
            ),
        },
        {
          path: "connections",
          name: "customer-settings-connections",
          component: () =>
            import("@/modules/Settings/views/Customer/Connections/index.vue"),
        },
        {
          path: "saml-sso",
          name: "customer-settings-saml-sso",
          component: () =>
            import("@/modules/Settings/views/Customer/Saml/index.vue"),
        },
      ],
    },
  ],
};

export default {};
